import Link from "next/link";
import { Linkedin, Instagram, Facebook } from "lucide-react";

export default function DocsFooter() {
  const productLinks = [
    { name: "ABSS Books", href: "/features/books" },
    { name: "ABSS CRM", href: "/features/crm" },
    { name: "Books Pricing", href: "/pricing/books" },
    { name: "CRM Pricing", href: "/pricing/crm" },
    { name: "Book a Demo", href: "/contact" },
  ];

  const documentationLinks = [
    { name: "Help Center", href: "/documentation" },
    {
      name: "Books Docs",
      href: "/documentation/books/getting-started/welcome",
    },
    { name: "CRM Docs", href: "/documentation/crm/getting-started/about" },
    { name: "Quick Start Guide", href: "/documentation/quick-start" },
  ];

  const resourceLinks = [
    { name: "Free Tools", href: "/tools" },
    { name: "GST Calculator", href: "/tools/gst-calculator" },
    { name: "Pipeline Calculator", href: "/tools/sales-pipeline-calculator" },
    { name: "Blog", href: "/blog" },
  ];

  const companyLinks = [
    { name: "About ABSS", href: "/about" },
    { name: "Contact Us", href: "/contact" },
    { name: "Partner Program", href: "/contact" },
  ];

  const socialLinks = [
    {
      Icon: Linkedin,
      label: "LinkedIn",
      href: "https://www.linkedin.com/company/abss-india",
    },
    {
      Icon: Instagram,
      label: "Instagram",
      href: "https://www.instagram.com/abss.team/",
    },
    {
      Icon: Facebook,
      label: "Facebook",
      href: "https://www.facebook.com/abss.team/",
    },
  ];

  const columns = [
    { title: "Products", links: productLinks },
    { title: "Documentation", links: documentationLinks },
    { title: "Resources", links: resourceLinks },
    { title: "Company", links: companyLinks },
  ];

  return (
    <footer className="docs-original-footer w-full bg-[#0B0B0B] border-t border-neutral-900 text-white overflow-hidden">
      <div className="max-w-[1160px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="text-[11px] geist-bold text-neutral-500 uppercase tracking-widest mb-3 sm:mb-4">
                {col.title}
              </h3>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      href={link.href}
                      className="text-[13px] geist-medium text-neutral-300 hover:text-white transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-neutral-900/60">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[12px] geist-regular text-neutral-400">
              © {new Date().getFullYear()} ABSS. All rights reserved.
            </p>

            <div className="flex items-center gap-3">
              {socialLinks.map(({ Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-neutral-900 border border-neutral-800/80 flex items-center justify-center text-neutral-500 hover:text-white hover:border-neutral-700 transition-colors shadow-sm"
                  aria-label={label}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>

            <div className="flex items-center gap-6">
              <Link
                href="/privacy-policy"
                className="text-[12px] geist-medium text-neutral-400 hover:text-white transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                href="/terms-of-service"
                className="text-[12px] geist-medium text-neutral-400 hover:text-white transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
